export const workoutTranslations = {
  FULL: {
    pre_title: '',
    title: 'Full',
    style: 'Workout',
    duration: '40-48',
    exercises: 52,
  },
  HALF: {
    pre_title: '',
    title: 'Half',
    style: 'Workout',
    duration: '20-24',
    exercises: 26,
  },
  CARD_DRAW_13: {
    pre_title: '',
    title: '13 Card',
    style: 'Draw',
    duration: '8-14',
    exercises: 13,
  },
  LADDER: {
    pre_title: '',
    title: 'Ladder',
    style: 'Workout',
    duration: '15-20',
    exercises: 25,
  },
  CARRIES_LEG_WORKOUT: {
    pre_title: "Carrie's",
    title: 'Leg Workout',
    style: '',
    duration: '40 - 70',
  },
  DENIM_AND_RHINESTONES: {
    pre_title: '',
    title: 'Denim & Rhinestones',
    style: 'Workout',
    duration: '10 - 14',
    exercises: 16,
  },
  TEST: {
    pre_title: '',
    title: 'Test',
    style: 'Workout',
    duration: '5',
    exercises: 8,
  },
  MINI: {
    pre_title: '',
    title: 'Mini',
    style: 'Workout',
    duration: '2',
    exercises: 4,
  },
  OVERNIGHT: {
    pre_title: '',
    title: 'Overnight',
    style: 'Workout',
    duration: 'Alot of',
    exercises: 500,
  },
  YOGA_BASICS: { title: 'Yoga Basics', duration: '11' },
  YOGA_FLOW_ESSENTIALS: { title: 'Yoga Flow Essentials', duration: '16' },
  YOGA_CORE_STRENGTH: { title: 'For Core Strength', duration: '11' },
  YOGA_RESTORATIVE: { title: 'Restorative Yoga', duration: '6' },
  YOGA_FOR_EVERYONE: { title: 'Yoga For Everyone', duration: '11' },
  YOGA_POWER_FLOW: { title: 'Power Flow Yoga', duration: '13' },
  INTRO_TO_FIT52: { title: "Carrie's Intro", duration: '10' },
  LOWER_BODY_BURN: { title: 'Lower Body Burn', duration: '14' },
  UPPER_BODY_BLAST: { title: 'Upper Body Blast', duration: '8' },
  KETTLEBELLS_WITH_CARRIE: { title: 'Kettlebells with Carrie', duration: '5' },
  CARRIES_HOT_HIIT: { title: "Carrie's Hot HIIT", duration: '8' },
  THE_FIT52_TEST: { title: 'The HiNote Test', duration: '12' },
  FIVE_X_FIVE_WORKOUT: { title: '5 x 5 Workout', duration: '7' },
  LEG_DAY_WITH_CARRIE_AND_EVE: {
    title: 'Leg Day with Carrie & Eve',
    duration: '8',
  },
  EVES_COOL_DOWN_SESSION: { title: "Eve's Cool-Down Session", duration: '18' },
  EVES_MOBILITY_SESSION: { title: "Eve's Mobility Session", duration: '25' },
  CARRIES_CARDIO: { title: "Carrie's Cardio", duration: '13' },
  STRONG_AND_SCULPTED_ARMS: { title: 'Strong & Sculpted Arms', duration: '15' },
  DUMBBELL_HIIT: { title: 'Dumbbell HIIT', duration: '15' },
  EVES_GO_TO_WARMUP: { title: "Eve's Go-To Warm-Up", duration: '10' },
  LOW_IMPACT_LOWER_BODY: { title: 'Low Impact Lower Body', duration: '16' },
  DYNAMIC_DUMBBELLS: { title: 'Dynamic Dumbbells', duration: '16' },
  CHIPPER_WORKOUT: { title: 'Chipper Workout', duration: '4' },
  FLASH_FIT_LOWER_BODY: {
    pre_title: 'Flash Fit',
    title: 'Legs',
    duration: '10-14',
    exercises: 13,
  },
  FLASH_FIT_CORE: {
    pre_title: 'Flash Fit',
    title: 'Core',
    duration: '8-14',
    exercises: 13,
  },
  FLASH_FIT_CARDIO: {
    pre_title: 'Flash Fit',
    title: 'Cardio',
    duration: '8-14',
    exercises: 13,
  },
  FLASH_FIT_UPPER_BODY: {
    pre_title: 'Flash Fit',
    title: 'Upper',
    duration: '10-14',
    exercises: 13,
  },
  RECOVER_STRETCH_YOGA_FLOW: {
    pre_title: '',
    title: 'Yoga Flow',
    style: '',
    duration: '4-7',
    exercises: 8,
  },
  RECOVER_STRETCH_WIND_DOWN: {
    pre_title: '',
    title: 'Wind Down',
    style: '',
    duration: '4-7',
    exercises: 8,
  },
  RECOVER_STRETCH_FULL_BODY_FLOW: {
    pre_title: '',
    title: 'Full-Body Flow',
    style: '',
    duration: '4-7',
    exercises: 8,
  },
  RECOVER_STRETCH_REVIVE_RECOVER: {
    pre_title: '',
    title: 'Revive & Recover',
    style: '',
    duration: '4-7',
    exercises: 8,
  },
  RECOVER_STRETCH_HIPS_LEGS: {
    pre_title: '',
    title: 'Hips & Legs',
    style: '',
    duration: '4-7',
    exercises: 8,
  },
  RECOVER_STRETCH_ENERGY_BOOSTER: {
    pre_title: '',
    title: 'Energy Booster',
    style: '',
    duration: '4-7',
    exercises: 8,
  },
  RECOVER_STRETCH_BACK_CHEST_FOAM_ROLLER: {
    pre_title: 'Foam Roller',
    title: 'Upper Body',
    style: '',
    duration: '4',
    exercises: 4,
  },
  RECOVER_STRETCH_LOWER_BODY_FOAM_ROLLER: {
    pre_title: 'Foam Roller',
    title: 'Lower Body',
    style: '',
    duration: '9',
    exercises: 5,
  },
  ALL_FAVORITE_SEGMENTS: {
    pre_title: '',
    title: 'Community Favorites',
    style: '',
    duration: '10-15',
    exercises: 13,
  },
  CARRIE_FAVORITE_SEGMENTS: {
    pre_title: '',
    title: "Carrie's Favorites",
    style: '',
    duration: '10-15',
    exercises: 13,
  },
  EVE_FAVORITE_SEGMENTS: {
    pre_title: '',
    title: "Eve's Favorites",
    style: '',
    duration: '10-15',
    exercises: 13,
  },
  GENERATOR_15: {
    pre_title: '',
    title: 'Workout Generator',
    style: '',
    duration: '13-15',
    exercises: 13,
  },
  GENERATOR_30: {
    pre_title: '',
    title: 'Workout Generator',
    style: '',
    duration: '28-30',
    exercises: 26,
  },
  GENERATOR_45: {
    pre_title: '',
    title: 'Workout Generator',
    style: '',
    duration: '43-45',
    exercises: 52,
  },
  DAILY_5_MOVE: {
    pre_title: 'Daily 5',
    title: 'Move',
    style: '',
    duration: '5',
    exercises: 5,
  },
  DAILY_5_STRETCH: {
    pre_title: 'Daily 5',
    title: 'Stretch',
    style: '',
    duration: '5',
    exercises: 5,
  },
  DAILY_5_SEATED_STRETCH: {
    pre_title: 'Daily 5',
    title: 'Seated',
    style: '',
    duration: '5',
    exercises: 5,
  },

  // fallback
  FALLBACK: {
    pre_title: 'Workout',
    title: 'Workout',
    style: '',
    duration: '',
    exercises: 1,
  },
};
